function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function createEl(tag, options) {
  const where = (options === null || options === void 0 ? void 0 : options.where) || 'inside';
  const peerEl = (options === null || options === void 0 ? void 0 : options.peerEl) || null;
  const attributes = (options === null || options === void 0 ? void 0 : options.attributes) || {};
  if (where) {
    if (['beforeFirstChild', 'inside', 'around'].indexOf(where) === -1) {
      throw new Error('Must provide valid `where` option');
    } else if (peerEl === null) {
      throw new Error('Must provide valid `peerEl` option');
    }
  }
  const element = document.createElement(tag);
  Object.entries(attributes).forEach(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      attr = _ref2[0],
      val = _ref2[1];
    if (element.hasAttribute(attr)) {
      element.removeAttribute(attr);
      element.setAttribute(attr, val);
    } else {
      element.setAttribute(attr, val);
    }
  });
  if (!peerEl) {
    throw new Error('peerEl not found');
  }
  if (where === 'around') {
    var _peerEl$parentNode;
    (_peerEl$parentNode = peerEl.parentNode) === null || _peerEl$parentNode === void 0 ? void 0 : _peerEl$parentNode.insertBefore(element, peerEl);
    element.appendChild(peerEl);
  } else if (where === 'inside') {
    peerEl.appendChild(element);
  } else if (where === 'beforeFirstChild') {
    if (peerEl.childNodes[0]) {
      peerEl.insertBefore(element, peerEl.childNodes[0]);
    } else {
      throw new Error('peerEl must have children to insertBefore');
    }
  }
  return element;
}
export default createEl;